<form (ngSubmit)="postSubTask()" #subtaskForm="ngForm" class="update-subtask-details-form">
  <p-card>
    <div class="row">
      <div class="col-md-12">
        <div class="tab">
          <p-tabView [(activeIndex)]="index" class="taskAllocation-tab" (onChange)="handleChange($event)">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <div class="row">
                  <span class="header-icon border rounded-circle p-3">
                    <i>1</i>
                  </span>
                  <hr style="width: 34%;position: absolute;top: 2rem;right:0" />
                </div>
                <label>Sub Task Details</label>
              </ng-template>
              <div class="container-fuild subTask-container">

                <div class="row col-md-12 mb-4 subTask-title">
                  <div class="col-md-10">
                    <h5>Sub Task Details</h5>
                  </div>
                  <div class="col-md-2 icons-title">
                    <span class="pi pi-times" (click)="handleSubTaskPanelToggle()"></span>
                  </div>
                </div>

                <div class="row mb-3"
                  *ngIf="task.id && task?.taskStatus.code === 'FILED' && (userType === 'Petitioner' || (task?.processingType === 'regular' && taskType !== 'I130'))">
                  <div class="col-12 mt-3">
                    <mat-accordion [togglePosition]="'before'" class="mt-2 pet-updte" style="width:100% !important;"
                      #petitionUpdateAccordian>
                      <mat-expansion-panel [expanded]="isPUExpanded" (opened)="puPanelOpenState = true"
                        (closed)="puPanelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            Would you like to make any updates to the Petitions
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-divider class="mt-n2" *ngIf="puPanelOpenState"></mat-divider>
                        <div class="dot-btm py-3" *ngIf="userType === 'Petitioner'">
                          <mat-checkbox name="PetionUpdates" [value]="'attorney'" [(ngModel)]="petitionUpdates[0]">
                            Add or change lawfirm
                          </mat-checkbox>
                        </div>
                        <div class="dot-btm py-3"
                          *ngIf="!fields?.disableProcessingType && (task?.processingType === 'regular' && taskType !== 'I130')">
                          <mat-checkbox name="PetionUpdates" [value]="'premium'" [(ngModel)]="petitionUpdates[1]">
                            Upgrade to premium processing
                          </mat-checkbox>
                        </div>
                        <button type="button" class="mt-3 btn btn-success"
                          [disabled]="!(petitionUpdates[0] || petitionUpdates[1])"
                          (click)="petitionUpdateBtnClickNext()">Next</button>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>


                <div class="row" ngModelGroup="petitionTaskForm" #petitionTaskForm="ngModelGroup">
                  <div class="col-md-12" *ngIf="fields.showExtraordinarySection">
                    <div class="form-group"><label class="create-task-label question required">Field of extraordinary
                        ability
                      </label></div>
                    <div class="mb-2" name="create-task-label question">
                      <p-dropdown [options]="fieldExtrAbltyCodeList" #fieldExtrAbltyCode="ngModel"
                        [(ngModel)]="task.fieldExtrAblty.code" name="fieldExtrAbltyCode" optionLabel="name"
                        optionValue="code" placeholder="Select field of extraordinary ability"
                        [disabled]="disabledControls" required>
                      </p-dropdown>
                      <span class="invalid-message"
                        *ngIf="(fieldExtrAbltyCode.touched || subtaskForm.submitted) && fieldExtrAbltyCode.errors?.required">
                        {{getGlobalErrorMessages('REQUIRED')}}
                      </span>
                    </div>
                    <div class="p-col-9">
                      <label for="tasktype" class="create-task-label question required">Applicable categories of
                        Documentary
                        Evidence</label>
                    </div>
                    <div class="p-col-12">
                      <div class="p-grid">
                        <div class="p-col-10">
                          <p-radioButton #extrAblDocEvdCatgCode="ngModel" [value]="extraBLDOCEVDNCATGList[0].code"
                            [(ngModel)]="task.extrAblDocEvdCatg.code" (click)="clickRadioBtn()"
                            label={{extraBLDOCEVDNCATGList[0].desc}}></p-radioButton>
                        </div>
                      </div>
                      <div class="p-grid mt-2 mb-2 ml-1">Or</div>
                      <div class="p-grid">
                        <div class="p-col-12">
                          <p-radioButton #extrAblDocEvdCatgCode="ngModel" [value]="extraBLDOCEVDNCATGList[1].code"
                            [(ngModel)]="task.extrAblDocEvdCatg.code" (click)="clickRadioBtn()"
                            label={{extraBLDOCEVDNCATGList[1].desc}}></p-radioButton>
                        </div>
                      </div>
                      <div class="p-grid mt-2 mb-2">
                        <div class="p-col-12" *ngFor="let item of majorInternationAwardList; let i = index;">
                          <p-checkbox [disabled]="this.task.extrAblDocEvdCatg.code === extraBLDOCEVDNCATGList[0].code"
                            #applicableOptionId="ngModel" [value]="item.code" [(ngModel)]="task.extrAblDocEvdList"
                            name="applicableOption" [label]="item.name">
                          </p-checkbox>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="p-grid mt-2 mb-2" *ngIf="task.questionAndResponseDTO && fields.showQuestionSection">

                      <div class="p-col-12"
                        *ngFor="let questionAndResponseDTO of task.questionAndResponseDTO ; let i = index;">


                        <div class="p-grid">
                          <div class="p-col-9" name="create-task-label question">
                            {{questionAndResponseDTO.question}}
                          </div>
                          <div class="p-col-1"
                            *ngIf="questionAndResponseDTO.isBoolean == 1 || questionAndResponseDTO.isBoolean">
                            <mat-slide-toggle color="primary" name="answer"
                              [checked]="questionAndResponseDTO.answer === 1"
                              (toggleChange)="onQuestionToggle(i,questionAndResponseDTO.answer)">
                            </mat-slide-toggle>
                          </div>
                        </div>

                        <div class="p-grid"
                          *ngIf="fields.showAdditionalAnswerForQuestions && questionAndResponseDTO.answer == 1">

                          <div class="p-col-5" *ngIf="i===0">
                            <label class="create-task-label required">How many?</label>
                            <p-inputNumber class="d-block" [min]="1" [max]="99" [maxlength]="2"
                              styleClass="create-task-input" [useGrouping]="false" placeholder="Enter"
                              [(ngModel)]="questionAndResponseDTO.additionalInfo" #howMany="ngModel" id="howMany"
                              name="howMany" [required]="questionAndResponseDTO.answer">
                            </p-inputNumber>
                            <span class="invalid-message"
                              *ngIf="howMany.touched && howMany.errors && additionalInfoRequired(questionAndResponseDTO)">
                              Required
                            </span>
                          </div>
                          <div class="p-col-10" *ngIf="i===1">
                            <label class="create-task-label required">Explanation</label>
                            <textarea rows="3" [(ngModel)]="questionAndResponseDTO.additionalInfo"
                              class="create-task-textarea d-block" placeholder="Enter" pInputTextarea
                              autoResize="autoResize" #Explanation="ngModel" id="Explanation" name="Explanation"
                              [required]="questionAndResponseDTO.answer"></textarea>
                            <span class="invalid-message"
                              *ngIf="Explanation.touched && Explanation.errors && additionalInfoRequired(questionAndResponseDTO)">
                              Required
                            </span>
                          </div>

                          <div class="mt-3 p-col-12"
                            *ngIf="!questionAndResponseDTO.isBoolean || questionAndResponseDTO.isBoolean == 0">
                            <input class="im-input mb-4" type="text" placeholder="Enter"
                              questionAndResponseDTO.additionalInfo />
                          </div>
                        </div>
                      </div>




                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="fields.showProcessingSection && task?.serviceCenterDetails">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>
                <div class="row" *ngIf="fields.showProcessingSection && task?.serviceCenterDetails">
                  <div class="col-md-4 form-group">
                    <label class="label-cls row"> Processing Type</label>
                    <p-radioButton #processingType="ngModel" name="processingType" (onClick)="onChangeProcessingType(0)"
                      value="0" class="mr-2" label="Regular" [(ngModel)]="task?.serviceCenterDetails.isPremiumCenter"
                      [disabled]="!isOutsideImagility || disabledControls || fields.disableProcessingType">
                    </p-radioButton>
                    <p-radioButton #processingType="ngModel" name="processingType" (onClick)="onChangeProcessingType(1)"
                      value="1" class="mr-2" label="Premium" [(ngModel)]="task?.serviceCenterDetails.isPremiumCenter"
                      [disabled]="!isOutsideImagility || disabledControls || fields.disableProcessingType">
                    </p-radioButton>
                    <span class="invalid-message"
                      *ngIf="(processingType.touched || subtaskForm.submitted) && processingType.errors?.required">
                      {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                  </div>
                </div>

                <div class="row" *ngIf="fields.showProcessingSection && task?.serviceCenterDetails">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>



                <div class="row">
                  <div class="form-group col-md-4 processing-dropdown" *ngIf="fields.showProcessingSection && task?.updatedServcieCenter?.oldServiceCenmterId"
                    [ngClass]="{'flex-grow-1 ': task?.taskStatus.code === 'FILED' || task?.updatedServcieCenter, 'col-4': task?.taskStatus.code !== 'FILED' && !task?.updatedServcieCenter}">
                    <label class="label-cls row required">Select {{task?.taskTypeDetails?.visaType === 'H1-B' ? 'Lockbox' : 'Service Center'}}</label>
                    <ng-template [ngIf]="!isFormEditable">
                      <label class="label-cls row mt-2 mb-0" *ngIf="!task?.updatedServcieCenter">{{
                        taskNonEdit?.serviceCenterName }}</label>
                      <label class="label-cls row mt-2 mb-0" *ngIf="task?.updatedServcieCenter">{{
                        task?.updatedServcieCenter.oldServiceCenmterName }}</label>
                    </ng-template>
                    <ng-template [ngIf]="isFormEditable">
                      <div class="form-group processing-dropdown">
                        <p-dropdown [options]="serviceCenterList"
                          [(ngModel)]="task.updatedServcieCenter ? task.updatedServcieCenter.oldServiceCenmterId : task.serviceCenterDetails.id "
                          #serviceCenterDetails="ngModel" name="serviceCenterDetails" optionLabel="name"
                          optionValue="id" (onChange)="getdropdownvalue($event)" placeholder="Select"
                          [disabled]="disabledControls" required>
                        </p-dropdown>
                        <span class="invalid-message"
                          *ngIf="(serviceCenterDetails.touched || subtaskForm.submitted) && serviceCenterDetails.errors?.required">
                          {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                      </div>
                    </ng-template>
                  </div>
                  <div class="form-group col-8  brdr-lft-lsr pb-3 position-relative"
                    [ngClass]="{'petition-updated': changeServiceCenterEdit && task?.updatedServcieCenter}"
                    *ngIf="task.id && (task?.taskStatus.code === 'FILED' || task?.updatedServcieCenter)">


                    <div class="row col-md-11 pl-0"
                      *ngIf="(changeServiceCenterEdit || !task?.updatedServcieCenter) && task?.taskStatus.code === 'FILED'">
                      <div class="row col-md-10 ">
                        <label class="label-cls row"></label>
                        <div class="col-md-10 pl-0 bold-label" name="question">
                          <label class="label-cls"> Is the USCIS Service Center different from where you filed the
                            petition?</label>
                        </div>
                        <div class="col-md-1">
                          <p-inputSwitch color="primary" [ngClass]="{'disabled': task?.updatedServcieCenter}"
                            [disabled]="task?.updatedServcieCenter" [(ngModel)]="uscisObj.changeUscisChecked"
                            #changeUscisChecked="ngModel" (onChange)="onChangeServiceCenter()"
                            name="changeUscisChecked">
                          </p-inputSwitch>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-12  brdr-lft-lsr pb-3 position-relative"
                    [ngClass]="{'petition-updated': changeServiceCenterEdit && task?.updatedServcieCenter}"
                    *ngIf="task.id && (task?.taskStatus.code === 'FILED' || task?.updatedServcieCenter)">

                    <div *ngIf="changeServiceCenterEdit">
                      <ng-template
                        [ngIf]="(uscisObj.changeUscisChecked && task?.taskStatus.code === 'FILED')||(task?.taskStatus.code === 'FILED' && changeServiceCenterEdit) ">
                        <div class="row mt-1 align-items-end">
                          <div class="col-md-4 pl-0 processing-dropdown">
                            <label class="label-cls row">New Service Center</label>
                            <p-dropdown [options]="serviceCenterList" [(ngModel)]="alteredServiceCenterId"
                              (ngModelChange)="onServiceCenterChanged()" name="alteredServiceCenterId"
                              optionLabel="name" optionValue="id" placeholder="Select Service center" required>
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="row mt-1 align-items-end pt-3">
                          <div class="col-md-12 px-0">
                            <div class="clearfix position-update-servicecenter">
                              <div class="h-100 file-upload-position">
                                <file-upload-library *ngIf="alteredServiceCenterId" style="width: 100%;"
                                  [fileUploadConfigurations]="fileUploadConfigurations"
                                  (isFileListModified)="handleIsFileListModified($event)">
                                </file-upload-library>
                              </div>
                              <div class="row col-md-12 p-0">
                                <div class="pl-3 mt-3 h-100 bdrlft-line">
                                  <button type="button" class="btn btn-primary float-left"
                                    [ngClass]="{'disabled': !alteredServiceCenterId || changeServiceCenter || alteredServiceCenterId === '0' || alteredServiceCenterId === ('' + task.serviceCenterDetails)}"
                                    (click)="changeUSCIS()"
                                    [disabled]="!alteredServiceCenterId || changeServiceCenter   || alteredServiceCenterId === '0' || alteredServiceCenterId === ('' + task.serviceCenterDetails)">
                                    Save
                                  </button>
                                </div>
                                <div class="pl-3 mt-3 h-100 bdrlft-line">
                                  <button type="button" pButton type="button" label="Cancel" icon="pi pi-times-circle"
                                    (click)="onServiceCenterClose()"
                                    *ngIf="changeServiceCenterEdit && task?.updatedServcieCenter"
                                    class="p-button-secondary cancel-btn button-width-icon-left d-flex alogn-items-center">
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-12 pr-0">
                            <div class="invalid-message" *ngIf="!receiptNumber">
                              <span>Please update the receipt details in 'Get Receipt' before continuing.</span>
                            </div>
                            <div class="invalid-message"
                              *ngIf="receiptNumber && (alteredServiceCenterId === ('' + task?.serviceCenterDetails))">
                              <span>Please select other service centre.</span>
                            </div>
                            <div class="invalid-message" *ngIf="receiptNumber && changeServiceCenter">
                              <span>Please upload 'CASE TRANSFER NOTICE'.</span>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </div>

                    <div class="row" *ngIf="task?.updatedServcieCenter && !changeServiceCenterEdit">
                      <div class="petition-updated petition-updated3 col-md-10 p-0">
                        <div class="row">
                          <div class="ml-auto">
                            <mat-icon *ngIf="task?.taskStatus.code === 'FILED'" (click)="onSercviceCenterEdit()"> edit
                            </mat-icon>
                            <mat-icon class="pl-2 green-icon material-icons">check_circle</mat-icon>
                          </div>
                        </div>
                        <div class="row mr-n2">
                          <div class="col-md-6 pl-0">
                            <label class="label-cls row">Updated Service Center</label>
                            <label class="label-dark">{{ task?.updatedServcieCenter?.newServiceCenmterName
                              }}</label>
                          </div>
                          <div class="col-md-6 brdr-lft-lsr">
                            <label class="label-cls row">Case Transfer Notice</label>
                            <label class="label-dark">{{ casetransferReceiptfileName }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="fields.showDividerBeforeForeignCompany">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>

                <div class="row"
                  *ngIf="fields.showForeignCompany || fields.showRelationshipOfUSCompanyWithForeignCompany || fields.showTreatyCountry">
                  <div class="col-md-4 form-group processing-dropdown" *ngIf="fields.showForeignCompany">
                    <label class="label-cls row">Foreign Company</label>
                    <ng-template [ngIf]="userType !== 'Beneficiary'">
                      <p-dropdown [options]="foreignCompanyList" [(ngModel)]="task.foreignCompanyId"
                        #foreignCompany="ngModel" name="foreignCompany" optionLabel="companyName" optionValue="id"
                        placeholder="Select Foreign Company" [disabled]="disabledControls" required>
                      </p-dropdown>
                      <span class="invalid-message"
                        *ngIf="(foreignCompany.touched || subtaskForm.submitted) && foreignCompany.errors?.required">
                        {{getGlobalErrorMessages('REQUIRED')}}
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="userType === 'Beneficiary'">
                      <input type="text" class="im-input mw-100" name="foreignCompany" [disabled]="disabledControls"
                        [(ngModel)]="task.foreignCompanyName" pInputText />
                    </ng-template>
                  </div>
                  <div class="col-md-4 form-group processing-dropdown"
                    *ngIf="fields.showRelationshipOfUSCompanyWithForeignCompany">
                    <label class="label-cls row">Relationship of US Company with Company
                      abroad</label>
                    <ng-template [ngIf]="userType !== 'Beneficiary'">
                      <p-dropdown [options]="companyRelationList" [(ngModel)]="task.foreignCompanyRelationCode"
                        #companyRelation="ngModel" name="companyRelation" optionLabel="name" optionValue="code"
                        placeholder="Select Relationship of US Company with Company
          abroady" [disabled]="disabledControls" required>
                      </p-dropdown>
                      <span class="invalid-message"
                        *ngIf="(companyRelation.touched || subtaskForm.submitted) && companyRelation.errors?.required">
                        {{getGlobalErrorMessages('REQUIRED')}}
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="userType === 'Beneficiary'">
                      <input type="text" class="im-input mw-100" name="companyRelation" [disabled]="disabledControls"
                        [(ngModel)]="task.foreignCompanyRelationName" pInputText />
                    </ng-template>
                  </div>
                  <div class="col-md-4 form-group processing-dropdown" *ngIf="fields.showTreatyCountry">
                    <label class="label-cls row">Treaty Country</label>
                    <!-- <input type="text" pInputText name="treatyCountryName" [(ngModel)]="task.treatyCountryName" [disabled]="disabledControls"
                      [readonly]="true" class="form-control txt-comp" /> -->
                    <p-dropdown class="w-100" [options]="treatyCountryList" [(ngModel)]="task.treatyCountryCode" name="treatyCountryCode"
                    optionLabel="countryName" optionValue="countryCode" placeholder="Select" [filter]="true" filterBy="countryName">
                    </p-dropdown>
                  </div>
                </div>

                <div class="row" *ngIf="fields.showSignatoryAndDesignation && task.signatoryDetails">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>

                <div class="row" *ngIf="fields.showSignatoryAndDesignation">
                  <div class="col-md-4 form-group processing-dropdown" *ngIf="task.signatoryDetails">
                    <label class="label-cls row required"> Signatory Name</label>
                    <p-dropdown [options]="signatoryEmployeeList" [(ngModel)]="task.signatoryDetails.id"
                      name="authorizedSignatory" #authorizedSignatory="ngModel" optionValue="id"
                      placeholder="Select Signatory" optionLabel="firstName" required
                      (onChange)="onSignatoryChange($event)" [disabled]="disabledControls">
                      <ng-template pTemplate="selectedItem">
                        <div *ngIf="task.signatoryDetails.id">
                          <div>{{task.signatoryDetails?.firstName + ' ' + task.signatoryDetails?.lastName}}</div>
                        </div>
                      </ng-template>
                      <ng-template let-employee pTemplate="item">
                        <div>
                          <div>{{employee?.firstName +' '+employee?.lastName}}</div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <span class="invalid-message"
                      *ngIf="(authorizedSignatory.touched || subtaskForm.submitted) && authorizedSignatory.errors?.required">
                      {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                  </div>
                  <div class="col-md-4 form-group processing-dropdown" *ngIf="task.signatoryDetails">
                    <label class="label-cls row"> Designation </label>
                    <input type="text" class="im-input mw-100" readOnly name="selectedDesignation"
                      [disabled]="disabledControls" [(ngModel)]="task.signatoryDetails.designation" pInputText />
                  </div>
                </div>

                <div class="row" *ngIf="fields.showSignatoryAndDesignation">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>
                <div class="row" *ngIf="fields.showConsulateSection">
                  <div class="col-md-4 form-group processing-dropdown">
                    <label class="label-cls row">Country</label>

                    <p-dropdown [options]="countryList" [(ngModel)]="task.consulate.countryCode.countryCode"
                      name="countryId" #countryId="ngModel" optionLabel="countryName" optionValue="countryCode"
                      placeholder="Select Country" (onChange)="getConsulateAddressByCountry()">
                    </p-dropdown>
                    <!-- <span class="invalid-message"
                      *ngIf="subtaskForm.get('countryId').touched && subtaskForm.get('countryId').errors?.required">
                      {{ getGlobalErrorMessages("REQUIRED") }}
                    </span> -->

                  </div>
                  <div class="col-md-4 form-group processing-dropdown">
                    <label class="label-cls row">Select Consulate</label>

                    <p-dropdown [options]="consulateList" [(ngModel)]="task.consulate.id" #consulateId="ngModel"
                      name="consulateId" optionLabel="consulateName" optionValue="id" placeholder="Select Consulate" (onChange)="onConsulateChange(task.consulate.id)">
                    </p-dropdown>
                    <!-- <span class="invalid-message"
                      *ngIf="petitionTaskForm.get('consulateId').touched && petitionTaskForm.get('consulateId').errors?.required">
                      {{ getGlobalErrorMessages("REQUIRED") }}
                    </span> -->

                  </div>

                </div>
                <div class="row" *ngIf="fields.showConsulateSection">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 form-group processing-dropdown">
                    <label class="label-cls row"> Lawfirm</label>
                    <label class="label-dark" *ngIf="taskType === 'I130'">{{employeeDetails?.companyName}}</label>
                    <label class="label-dark"
                      *ngIf="taskType !== 'I130' && attorneyFirmList.length <= 1">{{task?.companyName}} </label>
                    <p-dropdown *ngIf="taskType !== 'I130' && attorneyFirmList.length > 1" [options]="attorneyFirmList"
                      [(ngModel)]="task.attorneyId" name="attorney" #attorney="ngModel" optionLabel="attorneyName"
                      optionValue="attorneyId" (onChange)="onAttorneyFirmChange(true)" placeholder="Select lawfirm"
                      [disabled]="disabledControls">
                    </p-dropdown>

                  </div>
                  <div class="col-md-4 form-group processing-dropdown">
                    <label class="label-cls row"> Authorized Signatory</label>
                    <label class="label-dark" *ngIf="taskType === 'I130'">{{employeeDetails?.firstName ?
                      employeeDetails?.firstName
                      +' '+employeeDetails?.lastName : '--'}}</label>
                    <p-dropdown *ngIf="taskType !== 'I130'" [options]="attorneyPreparerEmployeeList"
                      [(ngModel)]="task.preparerAttorneyId" name="preparerAttorney" #preparerAttorney="ngModel"
                      optionLabel="firstName" optionValue="id" placeholder="Select Preparer"
                      (onChange)="onAttorneyPreparerChange($event)" [disabled]="disabledControls">
                      <ng-template pTemplate="selectedItem">
                        <div *ngIf="task.preparerAttorneyId">
                          <div>{{task?.preparerAttorneyName}}</div>
                        </div>
                      </ng-template>
                      <ng-template let-employee pTemplate="item">
                        <div>
                          <div>{{employee?.firstName + ' '+ employee?.lastName }}</div>
                        </div>
                      </ng-template>
                    </p-dropdown>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <p-divider type="dashed"></p-divider>
                  </div>
                </div>
                <div class="row" *ngIf="task.attorneyId !== task.companyId">
                  <div class="col-md-4 form-group processing-dropdown">
                    <label class="label-cls row required"> Petitioner Preparer Information</label>
                    <p-dropdown [options]="petitionerPreparerEmployeeList" [(ngModel)]="task.immSpecialistId"
                      name="immSpecialist" optionLabel="firstName" optionValue="id" #immSpecialist="ngModel"
                      placeholder="Select Petitioner Preparer" (onChange)="onPetitionerPreparerChange($event)"
                      [disabled]="disabledControls" required>
                      <ng-template pTemplate="selectedItem">
                        <div *ngIf="task.immSpecialistId">
                          <div>{{task.preparePetitionerName}}</div>
                        </div>
                      </ng-template>
                      <ng-template let-employee pTemplate="item">
                        <div>
                          <div>{{employee?.firstName +' '+employee?.lastName}}</div>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    <span class="invalid-message"
                      *ngIf="(immSpecialist.touched || subtaskForm.submitted) && immSpecialist.errors?.required">
                      {{getGlobalErrorMessages('REQUIRED')}}
                    </span>
                  </div>
                </div>
                <div class="row pt-4 pb-4">
                  <div class="p-col-1 btn-width mr-3">
                    <button pButton class="ml-3 p-button-primary save-btn" label="Next" title="Next" type="button"
                     (click)="stepStepTime()"
                      [disabled]="subtaskForm.invalid  || disabledControls || (task.taskTypeDetails.visaType && (task.taskTypeDetails.visaType === 'O1A' || task.taskTypeDetails.visaType === 'O1B') && task.extrAblDocEvdCatg.code && task.extrAblDocEvdCatg.code === 'OTHERDOCEVDN' && task.extrAblDocEvdList.length < 3)"></button>
                  </div>

                  <div class="p-col-1 btn-width">
                    <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left
        d-flex alogn-items-center" [disabled]="disabledControls" (click)="onCancel()">
                    </button>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel
              [disabled]="subtaskForm.invalid  || disabledControls || (task.taskTypeDetails.visaType && (fields?.showExtraordinarySection) && task.extrAblDocEvdCatg?.code && task.extrAblDocEvdCatg?.code === 'OTHERDOCEVDN' && task.extrAblDocEvdList?.length < 3)">
              <ng-template pTemplate="header">
                <div class="row">
                  <hr style="width: 34%;position: absolute;top: 2rem;" />
                  <span class="header-icon border rounded-circle p-3">
                    <i>2</i>
                  </span>
                </div>
                <label>Task Allocation</label>
              </ng-template>
              <ng-template pTemplate="content">
                <!-- <p>sagar working component</p> -->
                <app-step-task-allocation [parentFormGroup]="null" [taskObj]="task" [index]="index"
                  (messageEvent)="receiveMessage($event)"></app-step-task-allocation>
                <div class="p-fluid p-formgrid p-grid px-3 pt-5">
                  <div class="p-col-1  pl-0 btn-width">
                    <button pButton type="button" class="p-button-secondary cancel-btn" label="Back" title="Back"
                      (click)="index = 0"></button>
                  </div>
                  <div class="p-col-1 btn-width">
                    <button pButton type="submit" label="Save" icon="pi pi-save"
                      [ngClass]="subtaskForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled save-btn':'btn-success button-width-icon-left mr-3'"
                      [disabled]="subtaskForm.invalid  || disabledControls || (task.taskTypeDetails.visaType && (fields?.showExtraordinarySection) && task.extrAblDocEvdCatg?.code && task.extrAblDocEvdCatg?.code === 'OTHERDOCEVDN' && task.extrAblDocEvdList?.length < 3)"></button>
                  </div>
                  <div class="p-col-1 btn-width pr-1 cancel-btn-outr">
                    <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left
      d-flex alogn-items-center" [disabled]="disabledControls" (click)="navigateToDashboard()">
                    </button>
                  </div>
                </div>
              </ng-template>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>

    </div>
  </p-card>

</form>